import { Controller } from "@hotwired/stimulus"
import videojs from "video.js"

export default class extends Controller {
  static targets = ["slide", "video", "dot"]
  static values = { interval: { type: Number, default: 8000 } }

  connect() {
    this.currentIndex = 0
    this.players = new Map()
    this.activateSlide(0)
    if (this.slideTargets.length > 1) {
      this.startTimer()
    }
  }

  disconnect() {
    this.stopTimer()
    this.players.forEach(player => {
      if (!player.isDisposed()) player.dispose()
    })
    this.players.clear()
  }

  startTimer() {
    this.timer = setInterval(() => this.nextSlide(), this.intervalValue)
  }

  stopTimer() {
    if (this.timer) clearInterval(this.timer)
  }

  resetTimer() {
    this.stopTimer()
    this.startTimer()
  }

  nextSlide() {
    const next = (this.currentIndex + 1) % this.slideTargets.length
    this.goTo(next)
  }

  goToSlide(event) {
    const index = parseInt(event.currentTarget.dataset.index)
    this.goTo(index)
    this.resetTimer()
  }

  goTo(index) {
    this.deactivateSlide(this.currentIndex)
    this.currentIndex = index
    this.activateSlide(index)
  }

  activateSlide(index) {
    const slide = this.slideTargets[index]
    slide.classList.add("active")
    if (this.hasDotTarget) {
      this.dotTargets.forEach((d, i) => d.classList.toggle("active", i === index))
    }
    const videoEl = slide.querySelector("video")
    if (videoEl) this.playVideo(index, videoEl)
  }

  deactivateSlide(index) {
    const slide = this.slideTargets[index]
    slide.classList.remove("active")
    this.pauseVideo(index)
  }

  playVideo(index, videoEl) {
    let player = this.players.get(index)
    if (!player) {
      const src = videoEl.dataset.src
      player = videojs(videoEl, {
        controls: false,
        autoplay: true,
        muted: true,
        loop: true,
        preload: "auto",
        loadingSpinner: false,
        bigPlayButton: false,
        textTrackDisplay: false,
        errorDisplay: false
      })
      if (src) {
        player.src({ type: "video/mp4", src: src })
      }
      this.players.set(index, player)
    } else {
      player.currentTime(0)
      player.play()
    }
  }

  pauseVideo(index) {
    const player = this.players.get(index)
    if (player && !player.isDisposed()) {
      player.pause()
    }
  }
}
